function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M336.17 0L258 111.991H282L360.576 0H336.17Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M284.5 0L307.5 33L295.5 51L260 0H284.5Z",
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M338.5 112L313 75.5L325 58L362.5 112H338.5Z",
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M230 0H251V111.991H230V107.808C223.935 111.118 216.972 113 209.567 113C186.058 113 167 94.0281 167 70.625C167 47.2219 186.058 28.25 209.567 28.25C216.972 28.25 223.935 30.1321 230 33.4419V0ZM209.343 94.4018C222.658 94.4018 233.452 83.6566 233.452 70.4018C233.452 57.147 222.658 46.4018 209.343 46.4018C196.028 46.4018 185.234 57.147 185.234 70.4018C185.234 83.6566 196.028 94.4018 209.343 94.4018Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M169.089 0L91 111.991H115.481L193.495 0H169.089Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M115.5 0L140 34L126.5 53L90 0H115.5Z",
  fill: "url(#paint2_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63 0H84V111.991H63V107.808C56.9349 111.118 49.9719 113 42.5673 113C19.058 113 0 94.0281 0 70.625C0 47.2219 19.058 28.25 42.5673 28.25C49.9719 28.25 56.9349 30.1321 63 33.4419V0ZM42.3431 94.4018C55.6581 94.4018 66.452 83.6566 66.452 70.4018C66.452 57.147 55.6581 46.4018 42.3431 46.4018C29.0281 46.4018 18.2342 57.147 18.2342 70.4018C18.2342 83.6566 29.0281 94.4018 42.3431 94.4018Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 279,
  y1: 7,
  x2: 311.925,
  y2: 46.7483,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.55
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 344,
  y1: 103.5,
  x2: 303.547,
  y2: 48.965,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6966FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6966FF",
  stopOpacity: 0.36
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 110,
  y1: 7.27451,
  x2: 144.132,
  y2: 49.0118,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0.55
})));

function SvgDydx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 113,
    viewBox: "0 0 363 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydx);
export default __webpack_public_path__ + "static/media/dydx.40327f8c2f796ee3a56f40463e5ac08f.svg";
export { ForwardRef as ReactComponent };